import { render, staticRenderFns } from "./SlideOutRelationshipElectiveAlert.vue?vue&type=template&id=47e37964&"
import script from "./SlideOutRelationshipElectiveAlert.vue?vue&type=script&lang=js&"
export * from "./SlideOutRelationshipElectiveAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports